import React from "react";

const IconClose = (props) => {
  return (
    <svg
      width={props.width || "22"}
      height={props.height || "22"}
      viewBox="0 0 14.252 14.252"
    >
      <rect
        id="Rectangle_145"
        dataname="Rectangle 145"
        width="17.995"
        height="2.159"
        transform="translate(1.527 0) rotate(45)"
        fill={props.fill || "#000"}
      />
      <rect
        id="Rectangle_146"
        dataname="Rectangle 146"
        width="17.995"
        height="2.159"
        transform="translate(14.252 1.527) rotate(135)"
        fill={props.fill || "#000"}
      />
    </svg>
  );
};

export default IconClose;
